import { z } from 'zod';
import { requiredString } from '../helpers';
export const Zendesk_Messaging_Handoff_1_ConfigValidator = z.object({
    subdomain: requiredString('Subdomain is required'),
    sunshineAppId: requiredString('Sunshine App ID is required'),
    userLinkBy: z.string().nullable().optional(),
    userName: z.string().optional(),
    userEmail: z.string().optional(),
    userPhone: z.string().optional(),
    ticketPriority: z.string().nullable().optional(),
    ticketOrganizationId: z.string().optional(),
    ticketGroupId: z.string().optional(),
    ticketAssigneeId: z.string().optional(),
    ticketTags: z.string().optional(),
    ticketBrandId: z.string().optional(),
    ticketCustomFields: z.record(z.string(), z.string().optional()).optional()
});
//# sourceMappingURL=zendesk-messaging-handoff-1.js.map